import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Vacancy } from '../types';

export const DELETE_VACANCY = 'DELETE_VACANCY';
export const DELETE_VACANCY_SUCCESS = 'DELETE_VACANCY_SUCCESS';

export interface DeleteVacancy {
    type: typeof DELETE_VACANCY;
    payload: {
        request: AxiosRequestConfig;
        vacancyId: string;
    };
}

export interface DeleteVacancySuccess {
    type: typeof DELETE_VACANCY_SUCCESS;
    payload: AxiosResponse<void>;
    meta: {
        previousAction: {
            payload: {
                vacancyId: string;
            };
        };
    };
}

export const deleteVacancy = (vacancy: Vacancy): DeleteVacancy => {
    const deleteLink = vacancy._links!.self;
    const deleteVacancyAction: DeleteVacancy = {
        type: DELETE_VACANCY,
        payload: {
            request: {
                method: 'DELETE',
                url: deleteLink.href
            },
            vacancyId: vacancy.id
        }
    };

    return deleteVacancyAction;
};



// WEBPACK FOOTER //
// ./src/scenes/administrator/actions/delete-vacancy-action.ts